import styled from "styled-components";
import { Image, Button } from "semantic-ui-react";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ themed }) => themed ? '#0f0e37' : 'inherit'};
  color: ${({ themed }) => themed ? '#fff' : 'inherit'}
`;

export const Container = styled.div`
  width: 100%;
  padding: ${(props) => (props.padding ? props.padding : "4em 5em 5em 5em")};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  @media (max-width: 1400px) {
    /* padding: 10% 0; */
    align-items: center;
  }
  @media (max-width: 900px) {
    /* padding: 10% 0; */
    align-items: center;
  }
  @media (max-width: 700px) {
    /* padding: 10% 0; */
  }
`;

export const FormContainer = styled.div`
  margin: 3em auto;
  width: ${(props) => (props.width ? props.width : "60%")};
  height: 100%;
  display: grid;
  grid-template-columns: ${(props) => (props.grid ? props.grid : "60% 40%")};
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  color: ${({ themed }) => themed ? '#bfbfbf' : 'inherit'};
  box-shadow: ${({ themed }) => themed ? '0 0 1px #ffff' : '0 0 1px #ff4500'};
`;

export const Form = styled.form`
  width: 100%;
  padding: 2em 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const FormDiv = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1em 0;
  margin-bottom: 0em;
`;

export const Label = styled.label`
  align-self: flex-start;
  font-size: 0.9em;
  padding-bottom: 0.4em;
  color: orangered;

  &.error {
    color: red;
  }
`;

export const Input = styled.input`
    width: 100%;
    padding: 0.5em 0em;
    outline: none;
    border: transparent;
    box-shadow: 0 1px 0px rgb(255 69 0 / 18%);
    background: transparent !important;

  &.error {
    border: 1px solid red;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    transition: all 0.5s ease-in-out;
  }
  &.success {
    border: 0.5px solid orangered;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    transition: all 0.5s ease-in-out;
  }

  &:focus {
    // transform: translate(0%, -1200%);
    transition: all 0.5s ease-in-out;
    background-color: transparent;
    box-shadow: 0 1px 0px rgb(255 69 0);
  }

  &::placeholder{
    color: grapy
  }
`;

export const H2 = styled.h2`
  text-align: center;
  font-size: 2.5em;
  color: orangered;
`;

export const ImageWrapper = styled(Image)`
  margin-bottom: 4em;
  height: 5em !important;
  width: 5em !important;
`;

export const LoginOptions = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: 0.85em;
    padding-bottom: 2em;
`
